import { render, staticRenderFns } from "./SchemaHotWordListConfig.vue?vue&type=template&id=cd8ae75c"
import script from "./SchemaHotWordListConfig.vue?vue&type=script&lang=js"
export * from "./SchemaHotWordListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports